import { compact as esCompact, pickBy } from "es-toolkit";

// from es-toolkit, which presumably uses the same definition as lodash
type NotFalsy<T> = Exclude<T, false | null | 0 | 0n | "" | undefined>;

export function compact<T>(obj: T[]): Array<NotFalsy<T>>;
export function compact<T>(obj: Record<string, T>): Record<string, NotFalsy<T>>;

export function compact<T, U>(obj: T[] | Record<string, U>): Array<NotFalsy<T>> | Record<string, NotFalsy<U>> {
  if (Array.isArray(obj)) {
    return esCompact(obj);
  }
  return pickBy(obj, (i) => !!i) as Record<string, NotFalsy<U>>;
}
